<div class="form-field-header">
  <div class="form-field-title-container">
    <span class="form-field-title">Authentication Token</span>
    <div
      class="form-field-info infoicon"
      matTooltip="The Bearer Token to be used when authenticating your SCIM Client to the SCIM Server via your Integration URL"
      matTooltipPosition="above"
    ></div>
  </div>
</div>
@if (!displayAuthToken) {
  <div class="row buttonRow center">
    @if (!generatingToken && !displayAuthToken) {
      <div class="download-button share-button" (click)="generateAuthToken()">
        <div class="token-icon icon-RotatePassword-RBAC"></div>
        <div>Generate Token</div>
        <div class="token-icon icon-ClickIcon"></div>
      </div>
    }
    @if (generatingToken) {
      <div class="download-button share-button">
        <div class="token-icon icon-RotatePassword-RBAC"></div>
        <div>Generating</div>
        <div class="token-icon generating-spinner"></div>
      </div>
    }
    @if (!generatingToken && serviceIdentityId && jwtConnectionId) {
      <label class="authTokenLabel bottomLabel">WARNING: Regenerating this token will cause the active authentication token to stop working.</label>
    }
  </div>
}

@if (displayAuthToken) {
  <div (click)="copyAuthToken()">
    <label class="authTokenLabel topLabel" for="authToken">This token will not be displayed again! Make sure you save it before closing this form, or you will need to generate a new one.</label>
    <textarea
      (click)="copyAuthToken()"
      [(ngModel)]="authToken"
      class="disabledAuthToken"
      readonly
      id="authToken"
    ></textarea>
  </div>
}